import React from 'react';
import styled from 'styled-components';

const StyledNonAbatixIcon = styled.svg`
  width: 30px;
  height: 30px;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
  transition: fill 0.2s ease;
`;

const NonAbatixIcon: React.FC = () => (
  <StyledNonAbatixIcon viewBox="0 0 24 24">
    <path d="M20.08 3.92C19.14 2.96 17.86 2.5 16.5 2.5H7.5C6.14 2.5 4.86 2.96 3.92 3.92 2.96 4.86 2.5 6.14 2.5 7.5v9c0 1.36.46 2.64 1.42 3.58.94.96 2.22 1.42 3.58 1.42h9c1.36 0 2.64-.46 3.58-1.42.96-.94 1.42-2.22 1.42-3.58v-9c0-1.36-.46-2.64-1.42-3.58zM7 7h10v2H7V7zm0 4h10v2H7v-2zm0 4h7v2H7v-2z" />
  </StyledNonAbatixIcon>
);

export default NonAbatixIcon;
